import { render, staticRenderFns } from "./ReAssignment.vue?vue&type=template&id=0d1ad9c8&"
import script from "./ReAssignment.vue?vue&type=script&lang=js&"
export * from "./ReAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports